import React, { useState, useEffect, useRef } from 'react';
import { Table, Typography } from 'antd';
import { ML_Ques_Category_Map } from './MLScore';
import { StringSeparator } from '../../common/constants';

const { Title, Text } = Typography;

const QuesCategoryBlock = ({ quesCat, attribute, showDiff }) => {
    const tableRef = useRef(null);
    const columns = [
        { title: 'Question', dataIndex: 'question', key: 'question', width: '30%' },
        {
            title: 'Existing Answer',
            dataIndex: 'answer',
            key: 'answer',
            width: '25%',
            render: (text) => <Text>{text instanceof Array ? text.join(StringSeparator.COMMA_SPACE) : text}</Text>,
        },
        {
            title: 'AI-Generated Answer',
            dataIndex: 'mlAnswer',
            key: 'mlAnswer',
            width: '25%',
            render: (text) => <Text>{text instanceof Array ? text.join(StringSeparator.COMMA_SPACE) : text}</Text>,
        },
    ];
    const [tableData, setTableData] = useState([]);
    const [selRow, setSelRow] = useState([]);
    useEffect(() => {
        const data = [];
        ML_Ques_Category_Map[quesCat.category_name] = {};
        quesCat.AppIndexQuestions.forEach((ques) => {
            if (showDiff) {
                if (!attribute[ques.question_col_name].isDifferent) {
                    return;
                }
            }
            ML_Ques_Category_Map[quesCat.category_name][ques.question_col_name] = { checked: true };
            data.push({
                key: ques.question_col_name,
                question: ques.question_summary ?? ques.question_text,
                answer: attribute[ques.question_col_name].researchData,
                mlAnswer: attribute[ques.question_col_name].mlResearchData,
            });
        });
        setTableData(data);
        setSelRow(data.map((row) => row.key));
    }, [showDiff]);

    const onChangeRowSelection = (selectedRowKeys, selectedRows) => {
        setSelRow(selectedRowKeys);
        Object.values(ML_Ques_Category_Map[quesCat.category_name]).forEach((ques) => {
            ques.checked = false;
        });
        selectedRows.forEach((row) => {
            ML_Ques_Category_Map[quesCat.category_name][row.key].checked = true;
        });
    };

    if (tableData.length === 0) {
        return <></>;
    }

    return (
        <div className='ns-margin-top-mid'>
            <Title level={5}>{quesCat.category_text}</Title>
            <Table
                ref={tableRef}
                size={'small'}
                columns={columns}
                dataSource={tableData}
                pagination={false}
                bordered={true}
                rowSelection={{
                    columnWidth: '5%',
                    type: 'checkbox',
                    selectedRowKeys: selRow,
                    onChange: onChangeRowSelection,
                }}
            />
        </div>
    );
};

export default QuesCategoryBlock;
